import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../Services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.css']
})
export class AppHeaderComponent {
  //@Input() userName: string | null = null;
  userName: string | null = null;
  displayName: string = '';
  userInitials: string = '';
  constructor(private readonly authService: AuthService, private router: Router) { }

  // Lifecycle
  ngOnInit(): void {
    const account = this.authService.activeAccount;

    if (!account) {
      this.authService.login();
    }
    else {
      this.userName = this.authService.getUserName();
      this.formatUserName(this.userName);
    }
  }
  formatUserName(name: string | null) {
    if (!name) return;

    // Remove role part
    const cleanName = name.split('(')[0].trim();

    // Split "LastName, FirstName"
    const parts = cleanName.split(',');

    const lastName = parts[0]?.trim();
    const firstName = parts[1]?.trim();

    // Display name
    this.displayName = `${firstName} ${lastName}`;

    // Initials
    this.userInitials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  }
  logout() {
    this.authService.logout();
    console.log('User logged out');
    this.router.navigate(['/login']); // redirect to login page
  }
}
